import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["limit"];
import { generateActivityFiltersV2 } from '../utils';

/**
 * This is the query builder for the v2 - activities API
 *
 * @param filters
 */
var generateV2ActivitiesFilters = function generateV2ActivitiesFilters() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var limit = filters.limit,
    restFilters = _objectWithoutProperties(filters, _excluded);
  return generateActivityFiltersV2(restFilters);
};
export default generateV2ActivitiesFilters;